/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1ClassroomdisciplineIdFoldersFolderid202,
  DeleteApiV1ClassroomdisciplineIdFoldersFolderid400,
  DeleteApiV1ClassroomdisciplineIdFoldersFolderid401,
  DeleteApiV1ClassroomdisciplineIdFoldersFolderid404,
  DeleteApiV1ClassroomdisciplineIdFoldersFolderidMutationResponse,
  DeleteApiV1ClassroomdisciplineIdFoldersFolderidPathParams,
} from "../../types/classPlanningMaterialController/DeleteApiV1ClassroomdisciplineIdFoldersFolderid.ts";

export const deleteApiV1ClassroomdisciplineIdFoldersFolderidPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
    folderId: z.coerce.number().int(),
  }) as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdFoldersFolderidPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const deleteApiV1ClassroomdisciplineIdFoldersFolderid202Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdFoldersFolderid202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const deleteApiV1ClassroomdisciplineIdFoldersFolderid400Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdFoldersFolderid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1ClassroomdisciplineIdFoldersFolderid401Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdFoldersFolderid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1ClassroomdisciplineIdFoldersFolderid404Schema =
  z.any() as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdFoldersFolderid404>;

export const deleteApiV1ClassroomdisciplineIdFoldersFolderidMutationResponseSchema =
  z.lazy(
    () => deleteApiV1ClassroomdisciplineIdFoldersFolderid202Schema,
  ) as unknown as ToZod<DeleteApiV1ClassroomdisciplineIdFoldersFolderidMutationResponse>;
